<section class="form-flow">
  <section class="mx-auto pr-24 pl-24 top max-w-660">
    <section class="back-link">
      <i class="fa-light fa-arrow-left mr-8"></i>

      <a [href]="vm.mmrPageLink" class="button-text" data-testid="back-to-repairs">Back to repairs page</a>
    </section>
    @if (vm.isLoading) {
      <app-skeleton-loader class="fill mt-40 h-32"> </app-skeleton-loader>
      <app-skeleton-loader class="fill mt-12 max-w-320 h-32"> </app-skeleton-loader>

      <app-skeleton-loader class="fill mt-20" />

      <app-skeleton-loader class="mt-20 fill p-16">
        <app-skeleton-loader class="fill max-w-240 h-28" />
        <app-skeleton-loader class="fill mt-12" />

        <section class="flex full-width gap-12" style="flex: 1">
          <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
          <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
        </section>

        <section class="flex full-width gap-12" style="flex: 1; justify-content: space-between">
          <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
          <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
        </section>
      </app-skeleton-loader>
    } @else {
      <h1 class="heading-1 mt-24 lg-mt-16">{{ vm.title }}</h1>

      <app-simple-progress-bar class="mt-12" [percentage]="vm.percentage" />

      @if (vm.showPaymentTaken) {
        <section class="payment-taken">
          <i class="fa-light fa-circle-check"></i>

          <p class="body">Thanks, we've got your payment.</p>
        </section>
      }

      <section class="card mt-24">
        <router-outlet></router-outlet>
      </section>
    }
  </section>
</section>
